/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VerifyUserResponse {
    getFixupPrototypeFunction() { return VerifyUserResponse.fixupPrototype; }

    static newInstance(model: Partial<VerifyUserResponse>): VerifyUserResponse {
        let obj = Object.assign(new VerifyUserResponse(), model);
        VerifyUserResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VerifyUserResponse>): VerifyUserResponse {
        if (!model) return null;
        return VerifyUserResponse.newInstance(<VerifyUserResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VerifyUserResponse) {
        if (!obj) return;

        models.VerifyUserResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VerifyUserResponse): boolean {
        Object.setPrototypeOf(obj, VerifyUserResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * user id
     */
    user_id: string;

    /**
     * user name
     */
    user_name: string;

    /**
     * user email
     */
    user_email: string;

    /**
     * user tenant names
     */
    tenant_names: Array<string>;

    /**
     * user name
     */
    account_master_name: string;

    /**
     * Contains information about the timezone set for the user.
     */
    timezone: string;

}
